import Account from './Account.vue';

export default [
  {
    path: '/my-account',
    redirect: () => ({
      name: 'account',
    }),
  },
  {
    name: 'account-profile',
    path: '/my-account/profile',
    component: Account,
    props: { tab: 'profile' },
  },
  {
    name: 'account-security',
    path: '/my-account/security',
    component: Account,
    props: { tab: 'security' },
  },
  {
    name: 'account-preferences',
    path: '/my-account/preferences',
    component: Account,
    props: { tab: 'preferences' },
  },
];
